import { useState } from "react";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { api } from "../lib/api";
import { setMailboxToken } from "../lib/mailboxLock";

export const MailboxUnlock = ({ address, onUnlocked, compact = false }) => {
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async (e) => {
    e?.preventDefault();
    setBusy(true);
    try { const r = await api.unlockMailbox(address, pin); setMailboxToken(address, r.token, r.expires_in); const legacy = pin.length !== 6; setPin(""); onUnlocked(); toast.success("تم فتح البريد لمدة 10 دقائق"); if (legacy) toast.warning("الرقم السري صار 6 أرقام — غيّر رقم هذا البريد من إعدادات قفل البريد"); }
    catch (er) { toast.error(er?.response?.data?.detail || "تعذّر الفتح"); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={go} data-testid="mailbox-unlock" className={compact ? "flex gap-2" : "mx-auto max-w-sm space-y-3 rounded-2xl border border-slate-200 bg-white p-6 text-center"}>
      {!compact && <><Lock className="mx-auto h-8 w-8 text-slate-500" /><p className="text-sm font-semibold text-slate-700">البريد <span dir="ltr">{address}</span> مقفل برقم سري</p></>}
      <Input data-testid="mailbox-unlock-pin" type="password" inputMode="numeric" maxLength={6} dir="ltr" value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
        placeholder="الرقم السري" className={compact ? "h-9 w-32 bg-white text-center" : "text-center tracking-[0.5em]"} autoFocus={!compact} />
      <Button type="submit" data-testid="mailbox-unlock-submit" disabled={busy || pin.length < 4} className={compact ? "h-9" : "w-full"}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : compact ? "فتح" : "فتح البريد"}</Button>
    </form>
  );
};
